<template>
	<div id="st-started">
		<div class="left">
			<div class="back" v-if="selected != 'introduce'" @click="onBack">
				<i class="fa fa-arrow-left"></i>
			</div>
			<div class="title">{{ student[selected].name }}</div>
			<div class="content">{{ student[selected].desc }}</div>
			<div class="logo">
				<img :src="require('@/assets/logo-2.png')" style="width: 180px;" />
			</div>
		</div>
		<div class="right">
			<div class="header">
				<span v-if="student[selected].type == 'checkbox'">{{$t('started.multiple-tip')}}</span>
			</div>
			<div class="content">
				<template v-for="(item, index) in student[selected].items">
					<div v-if="student[selected].showTotal > index" class="item" :class="student[selected].value.indexOf(item.value) != -1 ? 'active ' + selected : selected" @click="onSelectEvent(index)">
						<i v-if="item.icon" :class="item.icon"></i>
						<div class="name">{{ $t(item.label) }}</div>
						<div v-if="student[selected].type == 'radio'" class="check">
							<span></span>
						</div>
						<div v-if="student[selected].type == 'checkbox'" class="check checkbox">
							<i v-if="student[selected].value.indexOf(item.value) != -1" class="fa fa-check-square"></i>
							<span v-else></span>
						</div>
						<div v-if="student[selected].type == 'input'" class="input">
							<el-input v-if="item.name=='age'" v-model="student[selected].value.age" :placeholder="$t('started.please-input')" @input="verify" />
							<el-select v-if="item.name=='gender'" v-model="student[selected].value.gender" @change="verify">
							      <el-option :label="$t('male')" value="1" />
							      <el-option :label="$t('female')" value="2" />
							</el-select>
							<el-select v-if="item.name=='timezone'" v-model="student[selected].value.timezone" @change="verify">
							      <el-option v-for="(it, ind) in timeZoneList" :label="it.name + ', ' + it.desc" :value="it.zone" />
							</el-select>
						</div>
					</div>
				</template>
				<div v-if="student[selected].showTotal<student[selected].items.length" class="show" @click="student[selected].showTotal=99999">{{$t('ShowAll')}}</div>
			</div>
			<div class="button">
				<el-button type="primary" style="width: 100%;" @click="onContinue" :disabled="disabled" :loading="loading">Continue</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import StudentApi from '@/api/student'
import Config from '@/utils/config'
import TimeControl from '@/utils/time-control'

export default {
	name: "st-started",
	components: {
		
	},
	data() {
		return {
			selected: "introduce",
			student: {
				introduce: {
					name: this.$t('started.introduce-name'),
					desc: this.$t('started.introduce-desc'),
					type: "input",
					value: [],
					items: [
						{
							icon: "",
							name: "age",
							label: this.$t('age'),
							value: "",
							check: ""
						},
						{
							icon: "",
							name: "gender",
							label: this.$t('gender'),
							value: "",
							check: ""
						},
						{
							icon: "",
							name: "timezone",
							label: this.$t('course.timezone'),
							value: "",
							check: ""
						}
					],
					showTotal: 15,
				},
				goal: {
					name: this.$t('started.goal-name'),
					desc: this.$t('started.goal-desc'),
					type: "radio",
					value: [],
					items: [],
					showTotal: 15,
				},
				level: {
					name: this.$t('started.level-name'),
					desc: this.$t('started.level-desc'),
					type: "radio",
					value: [],
					items: [],
					showTotal: 15,
				},
				interests: {
					name: this.$t('started.interests-name'),
					desc: this.$t('started.interests-desc'),
					type: "checkbox",
					value: [],
					items: [],
					showTotal: 5,
				}
			},
			steps: ["introduce", "goal", "level", "interests"],
			loading: false,
			disabled: true,
			timeZoneList: []
		}
	},
	computed: {
	},
	created() {
		let studentConfigInfo = Config.studentConfigInfo();
		studentConfigInfo.goal.forEach((item, index) => {
			this.student.goal.items.push({name: "goal", label: item.label, value: item.value})
		});
		studentConfigInfo.level.forEach((item, index) => {
			this.student.level.items.push({name: "level", label: item.label, value: item.value})
		});
		studentConfigInfo.interests.forEach((item, index) => {
			this.student.interests.items.push({name: "interests", label: item.label, value: item.value})
		});
		this.timeZoneList = Config.timeZoneList();
		this.student.introduce.value.timezone = TimeControl.getTimeZone();
	},
	methods: {
		onSelectEvent(index) {
			let item = this.student[this.selected].items[index];
			if(this.student[this.selected].type == "radio") {
				this.student[this.selected].value = [item.value];
			} else if(this.student[this.selected].type == "checkbox") {
				let key = this.student[this.selected].value.indexOf(item.value);
				if(key == -1) {
					this.student[this.selected].value.push(item.value);
				} else {
					this.student[this.selected].value.splice(key, 1)
				}
			}
			this.verify();
		},
		verify() {
			let form = {
				age: this.student["introduce"].value.age || 0,
				gender: this.student["introduce"].value.gender || 0,
				timezone: this.student["introduce"].value.timezone || TimeControl.getTimeZone(),
				goal: this.student["goal"].value[0] || 0,
				level: this.student["level"].value[0] || 0,
				interests: this.student["interests"].value || [],
			};
			if(form.age == 0 && this.selected == "introduce") {
				// this.$message.error(this.$t('age-need'))
				return
			}
			if(form.gender == 0 && this.selected == "introduce") {
				// this.$message.error(this.$t('gender-need'))
				return
			}
			if(form.goal == 0 && this.selected == "goal") {
				// this.$message.error(this.$t('started.goal-name'))
				return
			}
			if(form.level == 0 && this.selected == "level") {
				// this.$message.error(this.$t('started.level-name'))
				return
			}
			if(form.interests.length == 0 && this.selected == "interests") {
				// this.$message.error(this.$t('started.interests-name'))
				return
			}
			this.disabled = false;
		},
		onContinue() {
			let form = {
				age: this.student["introduce"].value.age || 0,
				gender: this.student["introduce"].value.gender || 0,
				timezone: this.student["introduce"].value.timezone || TimeControl.getTimeZone(),
				goal: this.student["goal"].value[0] || 0,
				level: this.student["level"].value[0] || 0,
				interests: this.student["interests"].value || [],
			};
			for(let i in this.steps) {
				if(this.steps[i] == this.selected) {
					let next = parseInt(i) + 1;
					if(this.steps[next]) {
						this.disabled = true;
						this.selected = this.steps[next];
						this.verify();
						break;
					} else {
						this.loading = true;
						StudentApi.started(form).then(res => {
							this.$store.dispatch('GetUserInfo');
							setTimeout(() => {
								this.$router.push({path: "/st/home"})
							}, 2500)
						})
					}
				}
			}
		},
		onBack() {
			let upIndex = "";
			for (let i in this.steps) {
				if(this.steps[i] == this.selected) {
					break;
				} else {
					upIndex = this.steps[i];
				}
			}
			if(!!upIndex) {
				this.selected = upIndex;
			}
			this.verify();
		}
	}
}
</script>
<style lang="less">
#st-started {
	display: flex;
	height: 100vh;
	overflow: hidden;
	.left {
		width: 50%;
		background: var(--el-color-primary);
		height: 100vh;
		display: flex;
		justify-content: center;
		padding: 0 30px;
		flex-direction: column;
		color: #222222;

		.title {
			font-size: 2.7rem;
			font-weight: 600;
		}

		.content {
			font-size: 18px;
			margin-top: 24px;
			line-height: 20px;
			color: rgba(34, 34, 34, 0.6);
		}

		.back {
			position: absolute;
			top: 30px;
			cursor: pointer;

			i {
				font-size: 20px;
				font-weight: 500;
			}
		}

		.logo {
			font-size: 25px;
			font-weight: 600;
			position: absolute;
			bottom: 50px;
			font-family: fantasy;
		}
	}
	.right {
		width: 50%;
		height: 100vh;
		padding: 30px;
    	box-sizing: border-box;
    	position: relative;
    	display: flex;
    	flex-direction: column;    	
	    align-items: flex-start;
	    flex-wrap: nowrap;
	    justify-content: center;

    	.header {
    		height: 40px;
    		color: gray;
    	}

    	.content {
    		display: flex;
    		flex-direction: column;
    		width: 100%;
    		gap: 10px;
    		overflow: auto;
    		height: 100%;
    		justify-content: center;

    		&::-webkit-scrollbar {
    			display: none;
    		}

    		.item {
    			display: flex;
    			align-items: center;
    			font-size: 16px;
    			position: relative;
    			cursor: pointer;
    			user-select: none;

    			border: 2px solid rgb(220, 220, 229);
    			padding: 15px 15px;
    			border-radius: 8px;

    			&.introduce {
    				padding: 4px 15px;
    			}

    			i {
    				font-size: 18px;
    				margin-right: 10px;
    				width: 25px;
    			}

    			.name {
    				flex-shrink: 0;
    			}

    			.input {
    				width: 100%;
    				margin-left: 10px;

    				.el-input__inner {
    					border: 0;
    				}

    				.el-select {
    					width: 100%;
    				}
    			}

    			.check {
    				position: absolute;
    				right: 15px;

    				span {
    					width: 20px;
    					height: 20px;
    					border: 2px solid rgb(220, 220, 229);
    					border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						box-sizing: border-box;
    				}

    				i {
    					font-size: 20px;
    					margin: unset;
    					width: auto;
    					color: var(--el-color-primary);
    				}

    				&.checkbox {
    					span {
    						border-radius: unset;
    					}
    				}
    			}

    			&.active {
    				border-color: var(--el-color-primary);

    				.check {
    					span {
    						border-color: var(--el-color-primary);

    						&::after {
								content: "";
								width: 12px;
								height: 12px;
								background: var(--el-color-primary); // #222222;
								display: block;
								border-radius: 50%;
    						}
    					}

    					&.checkbox {
	    					span {
	    						&::after {
		    						border-radius: unset;
		    					}
	    					}
	    				}
    				}
    			}
    		}

    		.show {
				text-decoration: underline;
				font-size: 14px;
				margin-top: 10px;
				cursor: pointer;
			}
    	}

    	.button {
			height: 50px;
			width: 100%;
			display: flex;
			align-items: flex-end;
    	}
	}
}
</style>